import { render } from "./InventoryTicker.vue?vue&type=template&id=3bdabc93&scoped=true"
import script from "./InventoryTicker.vue?vue&type=script&lang=js"
export * from "./InventoryTicker.vue?vue&type=script&lang=js"

import "./InventoryTicker.vue?vue&type=style&index=0&id=3bdabc93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bdabc93"]])

export default __exports__